/* eslint-disable camelcase */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find } from 'lodash'
import { history } from '../../../../../store'
import dayjs from 'dayjs'
import Operations from '../../../../../operations'
import Selectors from '../../../../../selectors'
import { Banner, HelpLink, Spinner } from '../../../../../components/generic'
import { ButtonOLD, PageHeader } from '@lmc/ui-kit'
import Glyph from '../../../../../LEGACY/Glyph'
import { Outlet } from 'react-router-dom'
import { withRouter } from '../../../../../withRouter'
import PdfExport from '../../../../../components/pdf/PdfExport'
import { isBrowser, isTablet } from 'react-device-detect'

const renderHeader = (props) => {
  const {
    medication,
    router: {
      params: { id, medication_id },
    },
    isPDF,
    resident,
  } = props

  const { name } = medication

  let backLink = `/residents/${id}/emar`
  // TODO: there are better ways to do this
  const screen =
    window.location && window.location.pathname.split('/').splice(-1)[0]
  const isDetailsScreen = screen === 'details' || screen === 'edit'
  if (isDetailsScreen) backLink += `/${medication_id}/chart`

  const pdfUrl = encodeURIComponent(
    `residents/${id}/pdf/emar/${medication_id}/chart?printpdf=1`
  )
  const url = `/api/services/pdf/export?url=${pdfUrl}`
  const pdfTitle = `${resident?.preferredName || resident.name.first} ${
    resident.name.last
  } - ${medication.medication.name}`

  return (
    <div id="test" style={isPDF ? styles.pdfPadding : {}}>
      <PageHeader onBack={history.back} title={name} gradient={false}>
        <div style={styles.buttonsContainer}>
          {!isDetailsScreen && !medication.deleted && (
            <div style={styles.headerButtonContainer}>
              <ButtonOLD
                type="secondary"
                icon={<Glyph name="pencil" />}
                onClick={() => {
                  history.push(`/residents/${id}/emar/${medication_id}/edit`)
                }}
              >
                Configuration
              </ButtonOLD>
            </div>
          )}
          {!isPDF && url && (
            <PdfExport
              pdfTitle={pdfTitle}
              url={url}
              text={isDesktop ? 'Download PDF' : 'PDF'}
              style={{ whiteSpace: 'nowrap' }}
            />
          )}
        </div>
      </PageHeader>
    </div>
  )
}

export function ResidentMedScreen(props) {
  const {
    emarRoundTimings,
    fetchData,
    medication,
    resident,
    user,
    router: { params },
  } = props

  let headerRef = null
  const setHeaderRef = (node) => {
    headerRef = node
  }

  // const [startDate, setStartDate] = React.useState(dayjs().subtract(14, 'days'))
  const startDate = dayjs().subtract(14, 'days')
  // const [endDate, setEndDate] = React.useState(dayjs())
  const endDate = dayjs()

  React.useEffect(() => {
    fetchData({
      medicationId: params.medication_id,
      residentId: params.id,
      startDate,
      endDate,
    })
    if (headerRef) {
      headerRef?.scrollIntoView(true)
      window.scrollTo(0, 0)
    }
  }, [])

  if (!emarRoundTimings || !medication || !resident || !user) return <Spinner />

  const isPDF =
    (window.location &&
      window.location.query &&
      window.location.query.printpdf) ||
    window.location.pathname.includes('pdf')

  return (
    <div ref={setHeaderRef} style={styles.wrapper}>
      {renderHeader({ ...props, isPDF })}
      {medication.deleted && (
        <Banner text="This medication has been discontinued." />
      )}
      <div style={isPDF ? styles.pdfPadding : {}}>
        <Outlet />
      </div>
      <div style={styles.helpLinkContainer}>
        <HelpLink supportLink="https://support.logmycare.co.uk/en/collections/2749236-emar" />
      </div>
    </div>
  )
}

ResidentMedScreen.propTypes = {
  emarRoundTimings: PropTypes.array.isRequired,
  fetchData: PropTypes.func.isRequired,
  medication: PropTypes.object.isRequired,
  resident: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
}

const styles = {
  headerButtonContainer: {
    paddingRight: 8,
  },
  helpLinkContainer: {
    marginTop: 24,
  },
  pdfFormButtonContainer: {
    marginRight: 10,
  },
  pdfWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 1190,
    minHeight: 1480,
    zIndex: 1000,
    background: 'white',
    padding: '24px 28px',
  },
  pdfPadding: { padding: '0px 24px' },
  wrapper: {
    padding: '24px 0px 48px',
    margin: '0px auto',
    maxWidth: 1080,
  },
  buttonsContainer: {
    display: 'flex',
  },
}

const isDesktop = isBrowser || isTablet

const mapStateToProps = (state, props) => ({
  emarRoundTimings: state.data['emar-round-timings'],
  medication: find(Selectors.getResidentMarChart(state, props), {
    id: props.router.params.medication_id,
  }),
  resident: Selectors.getResidentProfile(state, { id: props.router.params.id }),
  user: Selectors.getCurrentUserProfile(state),
})

const mapDispatchToProps = (dispatch) => ({
  fetchData: ({ medicationId, residentId, startDate, endDate }) => {
    dispatch(Operations.loadList('emar-round-timings'))
    dispatch(Operations.loadListItem('emar-resident-medications', medicationId))
    dispatch(
      Operations.loadList('emar-rounds', {
        resident: residentId,
        from: dayjs(startDate).startOf('day').toISOString(),
        to: dayjs(endDate).endOf('day').toISOString(),
      })
    )
  },
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResidentMedScreen)
)
